import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from "pinia";
import { onMounted, ref, computed } from "vue";
import BannerElem from "@/components/BannerView.vue";
import LoginElem from "@/components/forms/LoginView.vue";
import CreateElem from "@/components/forms/CreateView.vue";
import ContactElem from "@/components/forms/ContactView.vue";
import MentionElem from "@/components/forms/MentionsView.vue";
import MenuElem from "@/components/MenuView.vue";
import MenuMobileElem from "@/components/MenuMobileView.vue";
import DoneView from "@/components/DoneView.vue";
import StoreMapper from "@/components/forms/StoreMapperView.vue";
import ExternalView from "@/components/ExternalLinkView.vue";

import { useOperationStore } from "@/stores/operation";
interface CustomStore {
  custom_css?: string;
}

import { elementsDirectionStore } from "@/stores/motions";

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutView',
  setup(__props) {

const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
const customStore: CustomStore = operationStore?.customData ?? {};

const motionsStore = elementsDirectionStore();
const { banner, blocLeft, blocRight } = storeToRefs(motionsStore);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { bannerDirection: bannerDirection, slideToReset } = motionsStore;

const path = ref<string>("register");
const pathMobile = ref<string>("login");
const reveal = ref<boolean>(false);
const status = ref<string>("wait");
const externallink = ref<string>("");
const counterHome = ref<any>(undefined);
const overquota = ref<boolean>(false);

const setPath = (newPath: string) => {
  if (newPath === "login") {
    banner.value = "right";
    setTimeout(() => {
      path.value = "register";
    }, 1000);
  } else {
    path.value = newPath;
    setTimeout(() => {
      banner.value = "left";
    }, 500);
  }
};

const setViewMobile = (newPath: string) => {
  pathMobile.value = newPath;
};

const getStatus = () => {
  if (op.value && op.value.date_debut && op.value.date_fin) {
    const dateBegin = new Date(op.value.date_debut);
    const dateOff = new Date(op.value.date_fin);
    const today = new Date();
    status.value = "open";

    if (!op.value.available) {
      status.value = "offline";
    } else if (dateOff > today && dateBegin > today) {
      status.value = "wait";
    } else if (dateOff < today) {
      status.value = "finish";
    }
  }
};

//const resetFront = () => {
//  slideToReset();
//  path.value = "register";
//};

const setExternallink = (link: string) => {
  banner.value = "left";
  externallink.value = link;
  path.value = "externallink";
  pathMobile.value = "externallink";
};

let style = ref<string>("");
onMounted(async () => {
  getStatus();
  operationStore.counterType = "HOME";
  counterHome.value = await operationStore.counterData;
  if (counterHome.value && counterHome.value.value <= 0) {
    overquota.value = true;
  }
  if (customStore?.custom_css) {
    style.value = `<style>${customStore.custom_css}</style>`;
  }
});

return { __sfc: true,operationStore, op, customStore, motionsStore, banner, blocLeft, blocRight, bannerDirection, slideToReset, path, pathMobile, reveal, status, externallink, counterHome, overquota, setPath, setViewMobile, getStatus, setExternallink, style, BannerElem, LoginElem, CreateElem, ContactElem, MentionElem, MenuElem, MenuMobileElem, DoneView, StoreMapper, ExternalView }
}

})